import { Provider } from 'react-redux';
import store from 'redux/store';

const connectedComponent = (Component) => (props) =>
  (
    <Provider store={store}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Component {...props} />
    </Provider>
  );

export { connectedComponent };
